module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWBAMAAAA2mnEIAAAAA3NCSVQICAjb4U/gAAAAKlBMVEX///////////////////////////////////////////////////////9q+00tAAAADnRSTlMAETNVZneImaq7zN3u/5A3Po4AAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAcdEVYdFNvZnR3YXJlAEFkb2JlIEZpcmV3b3JrcyBDUzbovLKMAAAAUklEQVQYlWNgIArsvQsCt8FsZWMQMMKmrFwAzpS6uxDGZNq9arcClG0zsUPyMITJep2hg6E2AMz2DQCyWa+A2UIMQDaDIkx3B5L5lLDTsDkYDgDRgBZQK+yE2AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/travel/side3.png
// module id = E81E
// module chunks = 1